import React from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Castellano1 from "../../../images/modulo14/castellano1.png";
import Castellano2 from "../../../images/modulo14/castellano2.png";

const Actividad1 = () => {
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[2];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[3].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[3].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[1].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[1].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-8 col-12 p-md-3 p-0">
            <h4 className="mb-4">
              <strong>¿Un castellano o varios castellanos?</strong>
            </h4>
            <p className="mt-1">
              En el Perú, muchos hablamos castellano, pero no hablamos{" "}
              <strong>el mismo castellano</strong>.
            </p>
            <p>
              Desde que llegó a nuestro territorio con los españoles, el
              castellano se fue extendiendo con sus <strong>variaciones</strong>
              . Así, el castellano que se habla en Piura no es igual al que se
              habla en Apurímac, por ejemplo. Pero tampoco es igual el que habla
              una niña de 10 años y el que habla un señor de 70.
            </p>
          </div>
          <div className="col-md-4 col-12">
            <img
              src={Castellano2}
              className="bg-white img-fluid rounded w-100"
              alt="dialogo"
            />
          </div>
          <div className="col-md-4 col-12">
            <img
              src={Castellano1}
              className="bg-white img-fluid rounded w-100"
              alt="dialogo"
            />
          </div>

          <div className="col-md-8 p-md-3 p-0 col-12">
            <p>
              A pesar de las diferencias en nuestras variedades de castellano,
              esta es la lengua que permite que la gran mayoría de peruanos nos
              comuniquemos.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean el texto titulado ¿Un
            castellano o varios castellanos? Recuérdeles que también deben
            observar y leer los diálogos que se presentan en las ilustraciones.
            Lea en voz alta el texto.
          </li>
          <li>
            Repita la pregunta del texto: “Entonces, según lo
            que hemos leído, ¿tenemos uno o varios castellanos?”. Recoja sus
            respuestas. Analicen las particularidades del castellano que aparece
            en las viñetas: Brayan utiliza algunas expresiones propias del
            castellano popular peruano, como “causita” o “pe”, que no
            necesariamente entienden todos los hablantes de castellano. Johnny
            usa la expresión “okey” que proviene del inglés. María usa la
            expresión “pro” que es propia de jóvenes y por eso Walter no la
            entiende.
          </li>
          <li>
            Cierre la sesión señalando que cada una de las millones de personas
            que habla castellano en el mundo, lo hace con sus particularidades.
            El castellano no es uno solo, está compuesto de diferentes
            variedades lingüísticas. En el Perú ocurre lo mismo. El castellano
            se habla de muchas maneras.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
